module.exports = __webpack_public_path__ + "img/abstract_bezier_curve.e42462eb.svg";